import React from "react";

/**
 * App page container. Single column on phone/tablet; at lg+ the optional `rail`
 * becomes a right-hand column so wide screens aren't mostly gutter. Only make the
 * rail sticky when its content is short enough to fit the viewport.
 */
export default function PageShell({ header, rail, stickyRail = false, children, className = "" }) {
  return (
    <main className={`max-w-7xl mx-auto px-4 md:px-6 pt-5 md:pt-8 pb-8 ${className}`}>
      {header && <div className="mb-4 lg:mb-6">{header}</div>}
      {rail ? (
        <div className="lg:grid lg:grid-cols-[minmax(0,1fr)_320px] xl:grid-cols-[minmax(0,1fr)_380px] lg:gap-6 xl:gap-8 lg:items-start">
          <div className="min-w-0 space-y-6">{children}</div>
          <aside className={`mt-6 lg:mt-0 space-y-4 ${stickyRail ? "lg:sticky lg:top-20" : ""}`}>{rail}</aside>
        </div>
      ) : (
        <div className="space-y-6">{children}</div>
      )}
    </main>
  );
}
